/* Keo bang CHUOT de cuon cac dai ngang (07/09/2026).
 *
 * Owner: "toi muon co the dung chuot hoac tay tren mobile de keo qua lai day anh nho thay vi
 * chi bam mui ten trai phai".
 *
 * Tren dien thoai cac dai nay VON da vuot duoc: base.css cho .slider--mobile / .slider--tablet-up
 * `overflow-x: auto` nen ngon tay cuon duoc san. Thu thieu la CHUOT tren may tinh - trinh duyet
 * khong tu cho keo mot vung overflow. File nay them dung viec do, khong dung gi den cham.
 *
 * PHAM VI (mang RAILS): dai anh nho trang san pham + hang chip chu de.
 * Them dai moi = them selector, khong phai viet lai.
 *
 * BON DIEM CAN NHO NEU SUA:
 * 1. CHI xu ly pointerType === 'mouse'. Cham va but de trinh duyet lo (cuon quan tinh, cao su
 *    hai dau) - keo tay bang JS luon te hon ban goc.
 * 2. base.css dat `scroll-snap-type: x mandatory` + `scroll-behavior: smooth` cho cac dai nay.
 *    Ca hai chong lai viec gan thang scrollLeft: snap keo ve o gan nhat sau moi khung hinh,
 *    smooth lam anh chay tre sau con tro. Trong luc keo phai tat ca hai - lam bang class
 *    .is-dragging trong assets/nh-trust-blocks.css (do dac hieu 0,2,0, thang base 0,1,0).
 * 3. Keo xong PHAI nuot dung MOT cu click ke tiep, neu khong tha tay o dau la trinh duyet coi
 *    nhu bam vao anh nho do va nhay sang anh khac. Co `swallowClick` duoc go o cu pointerdown
 *    ke tiep chu KHONG dung setTimeout: thu tu pointerup -> click khong dam bao cung mot vong
 *    su kien tren moi trinh duyet.
 * 4. Anh trong dai la <img>, trinh duyet mac dinh cho keo-tha anh; phai chan `dragstart`.
 */
(function () {
  'use strict';

  var RAILS = ['.thumbnail-slider .thumbnail-list', '.nh-chipbar__rail'];
  var THRESHOLD = 4; // px - duoi nguong nay van la mot cu bam, khong phai keo

  function setup(el) {
    if (el.dataset.nhDragReady) return;
    el.dataset.nhDragReady = '1';

    var down = false;
    var dragging = false;
    var swallowClick = false;
    var startX = 0;
    var startLeft = 0;

    function scrollable() {
      return el.scrollWidth - el.clientWidth > 2;
    }

    // Chi hien con tro ban tay khi that su co cho de keo.
    function syncAffordance() {
      el.classList.toggle('nh-dragscroll', scrollable());
    }

    syncAffordance();
    window.addEventListener('resize', syncAffordance, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(syncAffordance).observe(el);

    el.addEventListener('pointerdown', function (event) {
      swallowClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !scrollable()) return;
      down = true;
      dragging = false;
      startX = event.clientX;
      startLeft = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        dragging = true;
        el.classList.add('is-dragging');
        // Giu moi pointermove ve el ke ca khi con tro ra ngoai khung.
        if (el.setPointerCapture) {
          try {
            el.setPointerCapture(event.pointerId);
          } catch (e) {}
        }
      }
      event.preventDefault();
      el.scrollLeft = startLeft - dx;
    });

    function release(event) {
      if (!down) return;
      down = false;
      if (!dragging) return;
      dragging = false;
      swallowClick = true;
      el.classList.remove('is-dragging');
      if (el.releasePointerCapture && event && event.pointerId !== undefined) {
        try {
          el.releasePointerCapture(event.pointerId);
        } catch (e) {}
      }
    }

    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('pointerleave', release);

    el.addEventListener(
      'click',
      function (event) {
        if (!swallowClick) return;
        swallowClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    el.addEventListener('dragstart', function (event) {
      if (dragging) event.preventDefault();
    });
  }

  function boot() {
    RAILS.forEach(function (sel) {
      [].slice.call(document.querySelectorAll(sel)).forEach(setup);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor keo tha section; gallery cung dung lai dai anh khi doi bien the.
  document.addEventListener('shopify:section:load', boot);
})();
